import { web3APIClient } from "@/api/api";
import {
  Connection,
  PublicKey,
  SystemProgram,
  Transaction,
} from "@solana/web3.js";

// Environment Configuration
export const rpcUrl = import.meta.env.PROD
  ? import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_PRODUCTION
  : import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_DEVELOPMENT;

export const solanaNetwork = import.meta.env.PROD ? "mainnet-beta" : "devnet";

/**
 * Execute payment
 *
 * @param {Wallet} wallet
 * @returns {Promise<string>} txSignature
 */
export const executePayment = async (wallet: any, personaId: string) => {
  try {
    // Get payment details from backend
    const paymentDetailsResponse = await web3APIClient.post(
      "/api/tokens/launchpad/payment-details",
      {
        solanaNetwork: solanaNetwork,
        userAddress: wallet.address,
        personaId: personaId,
      },
    );
    if (paymentDetailsResponse.status !== 200) {
      const responseDetail = paymentDetailsResponse.data;
      console.log("Response detail", responseDetail);
      if (
        responseDetail.detail &&
        responseDetail.detail === "Persona already has a token."
      ) {
        throw new Error("Agent already has a token.");
      }
      throw new Error("Failed to fetch payment details");
    }

    const { operatorWallet, feeLamports } = paymentDetailsResponse.data;

    // Create payment transaction
    const paymentTx = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: new PublicKey(wallet.address),
        toPubkey: new PublicKey(operatorWallet),
        lamports: BigInt(feeLamports),
      }),
    );

    // Send transaction
    const connection = new Connection(rpcUrl);
    const txSignature = await wallet.sendTransaction(paymentTx, connection);
    console.log("Transaction sent:", txSignature);

    // Return tx signature
    return txSignature;
  } catch (error) {
    console.error("Error in getPaymentDetails:", error);
    throw error;
  }
};

/**
 * Creates the mint transaction and waits for confirmation from the backend.
 *
 * @param {*} wallet
 * @param {*} formData
 * @returns
 */
export const mintToken = async (
  wallet: any,
  paymentSignature: any,
  formData: any,
) => {
  try {
    // Add required data to formData
    formData.append("userAddress", wallet.address);
    formData.append("paymentSignature", paymentSignature);
    formData.append("solanaNetwork", solanaNetwork);

    // Get mint transaction from backend
    const mintResponse = await web3APIClient.post(
      `/api/tokens/launchpad/mint`,
      formData,
    );
    if (mintResponse.status !== 200) {
      throw new Error("Failed to mint token");
    }

    return mintResponse.data;
  } catch (error) {
    console.error("Error in mintToken:", error);
    throw error;
  }
};
